import axios from 'axios'
import {
    baseUrl
} from './env'
import Vue from 'vue'
import {
    Dialog
} from 'vant';
const ajax = axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    }
});
ajax.interceptors.request.use(function (config) {
    if (!!window.abp.auth.getToken()) {
        config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
    return config;
}, function (error) {

    return Promise.reject(error);
});
let vm = new Vue({});
ajax.interceptors.response.use((respon) => {
    return respon.data
}, (error) => {
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
        if(error.response.data.error.details.indexOf('请先登陆')!=-1){
            window.abp.auth.clearToken();
            location.href="http://"+location.host;
            return;
        }
        Dialog({
            title:'温馨提示',
            message: error.response.data.error.details
        })
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
        if(error.response.data.error.message.indexOf('请先登陆')!=-1){
            window.abp.auth.clearToken();
            location.href="http://"+location.host;
            return;
        }
        Dialog({
            title: '温馨提示',
            message: error.response.data.error.message
        })
    } else if (error.response.status==404) {
        Dialog({
            message: '系统可能在更新,请稍后重试'
        });
    }
    setTimeout(() => {
        vm.$Message.destroy();
    }, 1000);
    return Promise.reject(error);
})
export default ajax;